import { useState, useMemo, createContext, useEffect } from 'react';
import Api from '../../api/api';

const PlansContext = createContext();
PlansContext.displayName = 'PlansContext';

export const DEFAULT_PLAN_ID = 1;
export const DEFAULT_PLAN_TITLE = 'ElecticBlaze';
export const DEFAULT_PLAN_PRICE = 5000;

const initialState = {
  id: DEFAULT_PLAN_ID,
  title: DEFAULT_PLAN_TITLE,
  price: DEFAULT_PLAN_PRICE
};

export default function PlansCtxComponent(children) {
  const [shown, setShown] = useState(false);
  const [plan, setPlan] = useState({});
  const [plans, setPlans] = useState();
  const [actions, setActions] = useState({
    onSuccess: () => {},
    onError: () => {}
  });

  useEffect(() => {
    Api.loadPlans()
      .then(plans => {
        setPlans(plans);
        const defaultPlan = plans.find(plan => plan.id === DEFAULT_PLAN_ID);
        setPlan(defaultPlan);
      })
      .catch(err => {
        setPlan(initialState);
        console.log(err);
      });
  }, []);

  function showPlan(props) {
    let id = props && props.id ? props.id : DEFAULT_PLAN_ID;
    const targetPlan = (plans && plans.find(plan => plan.id == id)) || initialState;
    props && props.onSuccess
      ? setActions(prev => Object.assign(prev, { onSuccess: props.onSuccess }))
      : setActions(prev => Object.assign(prev, { onSuccess: () => {} }));
    props && props.onError
      ? setActions(prev => Object.assign(prev, { onError: props.onError }))
      : setActions(prev => Object.assign(prev, { onError: () => {} }));
    setPlan(targetPlan);
    setShown(true);
  }

  function hidePlan() {
    setShown(false);
  }

  const contextValue = useMemo(
    () => ({ shown, setShown, showPlan, hidePlan, plan, setPlan, plans, actions, setActions }),
    [shown, plan, plans, actions]
  );

  return <PlansContext.Provider value={contextValue}>{children}</PlansContext.Provider>;
}

PlansCtxComponent.context = PlansContext;
